import i18next from 'i18next'
import { List } from 'immutable'
import { listFromOption, loadingAsyncState } from 'widgets-for-react'
import {
  canSafelyCast,
  TypeCastingValidator,
} from '../../../../utils/safe-type-casting'
import { imageValidator } from '../../image/imageApi'
import { ComponentTeaserData } from './componentTeasersState'

export const componentTeaserValidator: TypeCastingValidator<ComponentTeaserData> =
  {
    kind: 'object',
    fieldsValidator: {
      Id: { kind: 'number' },
      Name: { kind: 'string' },
      ImageURL: imageValidator,
      IsUserComponent: { kind: 'boolean' },
      IsDraft: { kind: 'boolean' }
    },
  }

export const loadComponentTeasers = (apicall: () => Promise<any>) =>
  loadingAsyncState(() =>
    apicall().then((raw) =>
      Array.isArray(raw)
        ? {
            kind: 'result',
            value: List(raw)
              .map((v) =>
                canSafelyCast<ComponentTeaserData>(componentTeaserValidator, {
                  ...v,
                  ImageURL: v.ImageURL || { Url: '', Title: '' },
                })
              )
              .flatMap<ComponentTeaserData>(listFromOption)
              .toArray(),
            status: 200,
          }
        : {
            kind: 'failed',
            status: 404,
          }
    )
  )

export async function getComponentTeasers(
  componentIds: number[]
): Promise<any> {
  const headers = new Headers()
  headers.append('content-type', 'application/json')
  const res = await fetch(
    `/api/v1/components/teasers?componentIds=${componentIds.join()}&language=${
      i18next.language
    }`,
    { method: 'get', headers: headers }
  )
  if (!res.ok) throw Error(res.statusText)
  return await res.json()
}
